import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IPostWebhooksBodyDto {
  companyId: number;
  events: WebhookEvents[];
  url: string;
  enabled: boolean;
  secret: string;
}

export class IPatchWebhooksBodyDto {
  enabled?: boolean;
}

export class Webhooks {
  id: string;
  companyId: number;
  events: WebhookEvents[];
  url: string;
  enabled: boolean;
  secret: string;
}

export class IWebhooksResponse {
  @Type(() => Webhooks)
  result: Webhooks;
}

export class IWebhooksListResponse extends IPagination {
  @Type(() => Webhooks)
  results: Webhooks[];
}

export class IWebhooksQueryDto extends IQueryPaginationDto {
  id?: string;
  name?: string;
  events?: WebhookEvents[];
}

export enum WebhookEvents {
  PACKAGE_STATUS = 'package_status',
  LATE_NOTIFICATION = 'late_notification',
  DAMAGE_NOTIFICATION = 'damage_notification',
  PACKAGE_RETURN_NOTIFICATION = 'package_return_notification',
  PACKAGE_DELIVERY = 'package_delivery',
  NEW_PACKAGE = 'new_package'
}
